<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEditBanking"
        :width="sizeSlideOver"
        :undo-enable="true"
        @close="handleClose"
        @undo="undo">
        <hts-card :title="$t('labels.editBankingInformation')">
            <div
                class="grid gap-5"
                :class="columnClass">
                <hts-form-input
                    :placeholder="companyName"
                    :label="$t('labels.companyName')"
                    :color="props.color"
                    :disabled="true"
                    name="company"
                    prop="company" />
                <hts-form-input
                    v-model="dataFormBanking.bankingName"
                    :label="$t('labels.bankingName')"
                    :required="true"
                    :color="props.color"
                    name="bankingName"
                    prop="bankingName" />
                <hts-form-input
                    v-model="dataFormBanking.bankingBranch"
                    :label="$t('labels.bankingBranch')"
                    :color="props.color"
                    name="bankingBranch"
                    prop="bankingBranch" />
                <hts-form-input
                    v-model="dataFormBanking.bankingAccountNumber"
                    :label="$t('labels.accountNumber')"
                    :color="props.color"
                    name="bankingAccountNumber"
                    prop="bankingAccountNumber" />
                <hts-form-input
                    v-model="dataFormBanking.accountHolderName"
                    :label="$t('labels.accountName')"
                    :color="props.color"
                    name="accountHolderName"
                    prop="accountHolderName" />
            </div>
        </hts-card>
    </hts-slide-over>
</template>

<script setup lang="ts">
import bankingData from './imports/banking-form'
const store = $store()
const companyName = ref('')
const dataFormBanking = reactive({ ...bankingData.initBanking })
onMounted(() => {
  companyName.value = store.system.company.name
})
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  bankingIsSelectedToEdit: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['close', 'refresh', 'undo'])
const handleClose = () => {
  emits('close')
}
watch(props, () => {
  _init()
})
const _init = () => {
  Object.assign(dataFormBanking, props.bankingIsSelectedToEdit)
}
const undo = () => {
  _init()
}

const handleSubmitFormEditBanking = () => {
  const api = $urlClient.company.updateBanking
  $api(api, { body: new URLSearchParams(dataFormBanking) })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        Object.assign(dataFormBanking, { ...data })
        emits('refresh')
        process.client && $toast().success($t('labels.editSuccess'))
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
